import {StudentReview} from '@/plugins/api'

const state = {
  studentReviews: [],
  studentReview: null,
  loading: false,
  error: null
}

const getters = {
  studentReviews: state => state.studentReviews,
  studentReview: state => state.studentReview,
  loading: state => state.loading,
  error: state => state.error
}

const mutations = {
  SET_STUDENT_REVIEWS(state, reviews) {
    state.studentReviews = reviews
  },
  SET_STUDENT_REVIEW(state, review) {
    state.studentReview = review
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchStudentReviews({commit}, query = {}) {
    try {
      commit('SET_LOADING', true)
      const reviews = await StudentReview.fetch(query)
      commit('SET_STUDENT_REVIEWS', reviews)
    } catch (error) {
      commit('SET_ERROR', error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchStudentReviewsForExcel({commit}, query = {}) {
    try {
      const reviews = await StudentReview.fetch(query)
      return reviews
    } catch (error) {
      commit('SET_ERROR', error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchStudentReview({commit}, id) {
    try {
      commit('SET_LOADING', true)
      const review = await StudentReview.get(id)
      commit('SET_STUDENT_REVIEW', review)
    } catch (error) {
      commit('SET_ERROR', error)
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createStudentReview({commit}, data) {
    try {
      commit('SET_LOADING', true)
      const review = await StudentReview.create(data)
      return review
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateStudentReview({commit}, {id, data}) {
    try {
      commit('SET_LOADING', true)
      const review = await StudentReview.update(id, data)
      return review
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteStudentReview({commit}, id) {
    try {
      commit('SET_LOADING', true)
      await StudentReview.delete(id)
    } catch (error) {
      commit('SET_ERROR', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
